import { search } from "../../BaseRepositoryComponents";

const hubAuthorization = process.env.REACT_APP_API_HUB_AUTHORIZATION;
const pathHub = process.env.REACT_APP_URL_API_HUB;

const pathFindProduto =
  pathHub +
  "/produto?cnpj=?1&marketplace=?2&somente_vinculados=?3&somente_nao_vinculados=?4";
const pathUsuarioMarketplaces = pathHub + "/usuario/?1/marketplaces";
const pathUsuarioMarketplacesAtualizar = pathHub + "/usuario/?1?marketplace=?2";
const pathAllMarketplaces = pathHub + "/marketplace";
const pathIncluirAnuncio = pathHub + "/produto?cnpj=?1&marketplace=?2";
const pathAtualizarAnuncio = pathHub + "/produto?cnpj=?1&marketplace=?2";
const pathDeletarAnuncio = pathHub + "/produto/?1?cnpj=?2&marketplace=?3";
const pathDeletarMarketplace =
  pathHub + "/usuario/?1?marketplace=?2&excluir_produtos=?3";
const pathVincularProduto = `${pathHub}/produto/?1/vincular_produto?cnpj=?2&marketplace_id=?3&produto_marketplace_id=?4`;

// TODO melhorar como será implementado
export function findMarketplaces(empresa_cnpj) {
  let consulta = pathUsuarioMarketplaces.replace("?1", empresa_cnpj);
  return search(consulta);
}

export function findAllMarketplaces() {
  let consulta = pathAllMarketplaces;
  return search(consulta);
}

export async function findProdutoMarketplace(
  empresa_cnpj,
  marketplaceId,
  vinculado = true,
  naoVinculado = false
) {
  let consulta = pathFindProduto
    .replace("?1", empresa_cnpj)
    .replace("?2", marketplaceId)
    .replace("?3", vinculado)
    .replace("?4", naoVinculado);

  let headers = new Headers();
  headers.append("Authorization", hubAuthorization);

  return search(consulta, "GET", headers);
}

export async function incluirAnuncio(empresa_cnpj, marketplaceId, anuncios) {
  let consulta = pathIncluirAnuncio
    .replace("?1", empresa_cnpj)
    .replace("?2", marketplaceId);

  let headers = new Headers();
  headers.append("Authorization", hubAuthorization);

  return search(consulta, "POST", headers, anuncios);
}

export async function vincularAnuncioService(
  empresa_cnpj,
  marketplaceId,
  estoqueId,
  marketplaceProdutoId
) {
  let consulta = pathVincularProduto
    .replace("?1", estoqueId)
    .replace("?2", empresa_cnpj)
    .replace("?3", marketplaceId)
    .replace("?4", marketplaceProdutoId);

  let headers = new Headers();
  headers.append("Authorization", hubAuthorization);

  return search(consulta, "POST", headers);
}

export async function atualizarAnuncio(empresa_cnpj, marketplaceId, anuncios) {
  let consulta = pathAtualizarAnuncio
    .replace("?1", empresa_cnpj)
    .replace("?2", marketplaceId);

  let headers = new Headers();
  headers.append("Authorization", hubAuthorization);

  return search(consulta, "PUT", headers, anuncios);
}

export async function excluirAnuncio(empresa_cnpj, marketplaceId, produtoId) {
  let consulta = pathDeletarAnuncio
    .replace("?1", produtoId)
    .replace("?2", empresa_cnpj)
    .replace("?3", marketplaceId);

  let headers = new Headers();
  headers.append("Authorization", hubAuthorization);

  return search(consulta, "DELETE", headers);
}

export async function excluirMarketplace(
  empresa_cnpj,
  marketplaceId,
  excluirItens = true
) {
  let consulta = pathDeletarMarketplace
    .replace("?1", empresa_cnpj)
    .replace("?2", marketplaceId)
    .replace("?3", "" + excluirItens);

  let headers = new Headers();
  headers.append("Authorization", hubAuthorization);

  return search(consulta, "DELETE", headers);
}

export async function atualizarUsuarioConfiguracoes(
  empresa_cnpj,
  marketplace_id,
  json
) {
  let consulta = pathUsuarioMarketplacesAtualizar
    .replace("?1", empresa_cnpj)
    .replace("?2", marketplace_id);

  let headers = new Headers();
  headers.append("Authorization", hubAuthorization);

  return search(consulta, "PATCH", headers, json);
}
